import React, { useEffect, useMemo, useRef, useState } from "react";
import { useCookies } from 'react-cookie';
import SymbolSearchPopup from "./SymbolSearchPopup";

export default function SetPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');

    const [isChecked, setIsChecked] = useState(false);

    const [symbolList, setSymbolList] = useState([]);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupAnchor, setPopupAnchor] = useState(null);
    const [isSymbolMenuOpen, setIsSymbolMenuOpen] = useState(false);
    const symbolDropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (symbolDropdownRef.current && !symbolDropdownRef.current.contains(event.target)) {
          setIsSymbolMenuOpen(false);
        }
      };

      const handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
          setIsSymbolMenuOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscapeKey);
      };
    }, []);

    useEffect(() => {
      if (!cookies.uuid) {
        redirectToLogin();
        return;
      }

      // uuid가 있을 때 서버로 요청 (authmiddleware가 처리)
      fetchUserInfo();
    }, [cookies.uuid]);

    const redirectToLogin = () => {
      alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
      window.location.href = '/LoginAts';
    };

    const fetchUserInfo = () => {
      fetch(`/kpversion_selected`)
        .then(res => res.json())
        .then(data => {
          if (data.message !== 'ok') {
            alert(data.message);
            window.location.href = '/SelectPage';
            return;
          }

          // 권한 OK → 유저 정보 요청
          return fetch('/GetUserInfo');
        })
        .then(res => res.json())
        .then(user => {
          setUID(user.uid);
          setNickname(user.nickname);
          fetchLists();
        })
        .catch(err => {
          redirectToLogin();
        });
    };

    // selectedlevel, entry, waiting list 받아오기
    const fetchLists = () => {
      fetch(`/startcheck/searchlevel`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          if(data[0].super_user === "8"){
            setLevelCheck(data[0].super_user);  
          }else{
            setLevelCheck(data[0].selectedLevel);
          }
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });

      fetch(`/startcheck_kp/list_entry`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, e_items, setE_Items);
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });
  
      fetch(`/startcheck_kp/list_wait`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, w_items, setW_Items);
        })
        .catch(error => {
          console.error('Waiting List 가져오기 오류:', error);
          alert(error);
        });
    };
  
    const updateList = (data, list, setList) => {
      for (let i = 0; i < data.length; i++) {
        if (!isItemInList(data[i].symbol, list)) {
          setList(prevList => [...prevList, data[i].symbol]);
        }
      }
    };

    const isItemInList = (item, list) => {
      return list.includes(item);
    };

    const[seed,setSeed] = useState('basic');

    const[symbol,setSymbol] = useState('default');
    const selectableSymbols = useMemo(
      () => Array.from(new Set(symbolList.filter((sym) => sym && sym !== 'default'))),
      [symbolList]
    );
    const currentSymbolLabel = symbol && symbol !== 'default' ? symbol : 'symbol select';

    const[leverage_info, setLeverage] = useState(20);

    const[benefit_mode,setBenefitMode] = useState('kinpoint');
    const[benefit_ratio,setBenefitRatio] = useState(0.35);
    const[losscut_usdt,setLosscutUsdt] = useState(200);

    const[start_ratio,setStartRatio] = useState(14);
    const[confirmed_ratio,setConfirmedRatio] = useState(50);
    const[max_ratio,setMaxRatio] = useState(50);

    const[long_count,setLongCount] = useState(0)
    const[short_count,setShortCount] = useState(0)

    const[reverse_mode,setReverseMode] = useState('no');

    const[entry_standard,setEntryStandard] = useState('no');
    const[ema_standard,setEmaStandard] = useState(200);
    const[ema_losscut,setEmaLosscut] = useState('no');
    const[entry_standard_candle,setEntryStandardCandle] = useState('4h');
    const[entry_standard_type,setEntryStandardType] = useState('haikin');

    const[entry_usdt_1, setEntryUsdt_1] = useState(10);
    const[entry_usdt_2, setEntryUsdt_2] = useState(10);
    const[entry_usdt_3, setEntryUsdt_3] = useState(10);
    const[entry_usdt_4, setEntryUsdt_4] = useState(10);
    const[entry_usdt_5, setEntryUsdt_5] = useState(10);
    const[entry_usdt_6, setEntryUsdt_6] = useState(10);
    const[entry_usdt_7, setEntryUsdt_7] = useState(10);
    const[entry_usdt_8, setEntryUsdt_8] = useState(10);
    const[entry_usdt_9, setEntryUsdt_9] = useState(10);

    const[entry_ratio_1, setEntryRatio_1] = useState(0);
    const[entry_ratio_2, setEntryRatio_2] = useState(3);
    const[entry_ratio_3, setEntryRatio_3] = useState(3);
    const[entry_ratio_4, setEntryRatio_4] = useState(3);
    const[entry_ratio_5, setEntryRatio_5] = useState(3);
    const[entry_ratio_6, setEntryRatio_6] = useState(3);
    const[entry_ratio_7, setEntryRatio_7] = useState(3);
    const[entry_ratio_8, setEntryRatio_8] = useState(3);
    const[entry_ratio_9, setEntryRatio_9] = useState(3);

    const[entry_candle,setEntryCandle] = useState('5m');
    const[direction,setDirection] = useState('both');

    //////////////////////////////////////////////////////////
    
    const[leverageValid,setLeverageValid] = useState(true);

    const[totalbenefitValid, setTotalbenefitValid] = useState(true);

    const[benefitratioValid, setBenefitratioValid] = useState(true);
    const[losscutUsdtValid, setLosscutUsdtValid] = useState(true);

    const[startratioValid, setStartratioValid] = useState(true);
    const[confirmedratioValid, setConfirmedratioValid] = useState(true);
    const[MaxratioValid, setMaxratioValid] = useState(true);

    const[emaStandardValid, setEmaStandardValid] = useState(true);

    const[entryusdtValid_1,setEntryUsdtValid_1] = useState(true);
    const[entryusdtValid_2,setEntryUsdtValid_2] = useState(true);
    const[entryusdtValid_3,setEntryUsdtValid_3] = useState(true);
    const[entryusdtValid_4,setEntryUsdtValid_4] = useState(true);
    const[entryusdtValid_5,setEntryUsdtValid_5] = useState(true);
    const[entryusdtValid_6,setEntryUsdtValid_6] = useState(true);
    const[entryusdtValid_7,setEntryUsdtValid_7] = useState(true);
    const[entryusdtValid_8,setEntryUsdtValid_8] = useState(true);
    const[entryusdtValid_9,setEntryUsdtValid_9] = useState(true);

    const[entryratioValid_1,setEntryRatioValid_1] = useState(true);
    const[entryratioValid_2,setEntryRatioValid_2] = useState(true);
    const[entryratioValid_3,setEntryRatioValid_3] = useState(true);
    const[entryratioValid_4,setEntryRatioValid_4] = useState(true);
    const[entryratioValid_5,setEntryRatioValid_5] = useState(true);
    const[entryratioValid_6,setEntryRatioValid_6] = useState(true);
    const[entryratioValid_7,setEntryRatioValid_7] = useState(true);
    const[entryratioValid_8,setEntryRatioValid_8] = useState(true);
    const[entryratioValid_9,setEntryRatioValid_9] = useState(true);

    const[setlevel, setLevelCheck] = useState(0);

    const[notAllow, setNotAllow] = useState(true);

    const[e_items, setE_Items] = useState([]);
    const[w_items, setW_Items] = useState([]);

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked);
    };

    const[search,setSearch] = useState(false);

    const[trade_start,setTradeStart] = useState(false);
    
    const[benefit_stop,setBenefit_stop] = useState(false);
    const[benefit_cancel,setBenefit_cancel] = useState(false);

    const[currentCoin_stop,setCurrentCoin_stop] = useState(false);
    const[allCoin_stop,setAllCoin_stop] = useState(false);

    const[end,setEnd] = useState(false);
    
    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //
    const handleEntryCandle = (e) => {
      setEntryCandle(e.target.value);
        };

    const handleBenefitMode = (e) => {
      setBenefitMode(e.target.value);
        };

    const handleDirection = (e) => {
      setDirection(e.target.value);
        };

    const handleReverseMode = (e) => {
      setReverseMode(e.target.value);
        };
    
    const handleEntryStandard = (e) => {
      setEntryStandard(e.target.value);
        };

    const handleEmaStandard = (e) => {
      const newemastandard = e.target.value.trim();
      setEmaStandard(newemastandard);
        const regex = 
        /^\d*$/;
        if (regex.test(newemastandard)) {
          setEmaStandardValid(true);
          } 
        else {
          setEmaStandardValid(false);
          }
        };

    const handleEmaLosscut = (e) => {
      setEmaLosscut(e.target.value);
        };

    const handleEntryStandardCandle = (e) => {
      setEntryStandardCandle(e.target.value);
        };

    const handleEntryStandardType = (e) => {
      setEntryStandardType(e.target.value);
        };

    const handleLeverage = (e) => {
      const newLeverage = e.target.value.trim();
      setLeverage(newLeverage);
        const regex = 
        /^\d*$/;
        if (regex.test(newLeverage)) {
          setLeverageValid(true);
          } 
        else {
          setLeverageValid(false);
          }
        };

    const handleStartRatio = (e) => {
      const newStartratio = e.target.value.trim();
      setStartRatio(newStartratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newStartratio)) {
          setStartratioValid(true);
          } 
        else {
          setStartratioValid(false);
          }
        };
    
    const handleConfirmedRatio = (e) => {
      const newConfirmedratio = e.target.value.trim();
      setConfirmedRatio(newConfirmedratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newConfirmedratio)) {
          setConfirmedratioValid(true);
          } 
        else {
          setConfirmedratioValid(false);
          }
        };

    const handleMaxRatio = (e) => {
      const newMaxratio = e.target.value.trim();
      setMaxRatio(newMaxratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newMaxratio)) {
          setMaxratioValid(true);
          } 
        else {
          setMaxratioValid(false);
          }
        };
    
    const handleBenefitratio = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitratioValid(true);
          } 
        else {
          setBenefitratioValid(false);
          }
        };

    const handleLosscutUsdt = (e) => {
      const newLosscutUsdt = e.target.value.trim();
      setLosscutUsdt(newLosscutUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newLosscutUsdt)) {
          setLosscutUsdtValid(true);
          } 
        else {
          setLosscutUsdtValid(false);
          }
        };

    
    // 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //
    const handleEntryUsdt_1 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_1(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_1(true);
          } 
        else {
          setEntryUsdtValid_1(false);
          }
        };
    const handleEntryUsdt_2 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_2(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_2(true);
          } 
        else {
          setEntryUsdtValid_2(false);
          }
        };
    const handleEntryUsdt_3 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_3(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_3(true);
          } 
        else {
          setEntryUsdtValid_3(false);
          }
        };
    const handleEntryUsdt_4 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_4(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_4(true);
          } 
        else {
          setEntryUsdtValid_4(false);
          }
        };
    const handleEntryUsdt_5 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_5(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_5(true);
          } 
        else {
          setEntryUsdtValid_5(false);
          }
        };
    const handleEntryUsdt_6 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_6(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_6(true);
          } 
        else {
          setEntryUsdtValid_6(false);           
          }
        };
    const handleEntryUsdt_7 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_7(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_7(true);
          } 
        else {
          setEntryUsdtValid_7(false);
          }
        };
    const handleEntryUsdt_8 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_8(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_8(true);
          } 
        else {
          setEntryUsdtValid_8(false);
          }
        };
    const handleEntryUsdt_9 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_9(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_9(true);
          } 
        else {
          setEntryUsdtValid_9(false);
          }
        };

        
    const handleEntryRatio_1 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_1(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_1(true);
          } 
        else {
          setEntryRatioValid_1(false);
          }
        };
    const handleEntryRatio_2 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_2(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_2(true);
          } 
        else {
          setEntryRatioValid_2(false);
          }
        };
    const handleEntryRatio_3 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_3(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_3(true);
          } 
        else {
          setEntryRatioValid_3(false);
          }
        };
    const handleEntryRatio_4 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_4(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_4(true);
          } 
        else {
          setEntryRatioValid_4(false);
          }
        };
    const handleEntryRatio_5 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_5(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_5(true);
          } 
        else {
          setEntryRatioValid_5(false);
          }
        };
    const handleEntryRatio_6 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_6(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_6(true);
          } 
        else {
          setEntryRatioValid_6(false);           
          }
        };
    const handleEntryRatio_7 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_7(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_7(true);
          } 
        else {
          setEntryRatioValid_7(false);
          }
        };
    const handleEntryRatio_8 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_8(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_8(true);
          } 
        else {
          setEntryRatioValid_8(false);
          }
        };
    const handleEntryRatio_9 = (e) => {
      const newEntryRatio = e.target.value.trim();
      setEntryRatio_9(newEntryRatio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryRatio)) {
          setEntryRatioValid_9(true);
          } 
        else {
          setEntryRatioValid_9(false);
          }
        };
    
    const handleAddSymbol = (symbol) => {
      const confirmed = window.confirm(`${symbol}을 리스트에 추가할까요?`);
      if (confirmed) {
      fetch(`/add_user_symbols_kp?symbol=${symbol}`)
      .then(res => res.json())
      .then(data => {
        if (data.msg) {
            alert(data.msg); // msg가 존재할 때만 출력
            return;
          }
        setSymbolList(data.signal)
      })
      .catch(err => console.error(err));
      }
    };

    const deleteSymbol = (symbol) => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      const confirmed = window.confirm(`${symbol}이 포지션이 걸려 있다면 리스트에서 삭제 후 수동으로 포지션 정리해주세요! ${symbol}을 삭제하시겠습니까?`);
      if (confirmed) {
      fetch(`/delete_user_symbols_kp?symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      removeListItem(symbol, setE_Items);
      removeListItem(symbol, setW_Items);
      setSymbol('default')
      }
    };

    const handleOpenPopup = (event) => {
      const rect = event.currentTarget.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const popupWidth = 300;
      const popupHeight = 320;

      const desiredTop = rect.top + scrollTop - popupHeight - 16;
      const top = Math.max(scrollTop + 20, desiredTop);
      const minLeft = scrollLeft + 16;
      const maxLeft = scrollLeft + viewportWidth - popupWidth - 16;
      const candidateLeft = rect.left + scrollLeft;
      const left = Math.min(Math.max(candidateLeft, minLeft), maxLeft);

      setPopupAnchor({ top, left });
      setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
      setIsPopupOpen(false);
      setPopupAnchor(null);
    };        

    const toggleSymbolMenu = () => {
      setIsSymbolMenuOpen((prev) => !prev);
    };

    const handleSymbolSelect = (value) => {
      setSymbol(value);
      if (value && value !== 'default') {
        onClickSearch(value);
      }
      setIsSymbolMenuOpen(false);
    };

    const addListItem = (newItem, listSetter) => {
      listSetter(prevList => [...prevList, newItem]);
    };

    const removeListItem = (itemName, listSetter) => {
      listSetter(prevList => prevList.filter(item => item !== itemName));
    };
    
    const onClickCoin = (coin) => {
      setSymbol(coin);
      onClickSearch(coin);
    }

    useEffect(() => {

      if(leverageValid && totalbenefitValid && startratioValid && confirmedratioValid && MaxratioValid &&
        benefitratioValid && losscutUsdtValid && emaStandardValid && entryusdtValid_1 && entryusdtValid_2 && entryusdtValid_3 && entryusdtValid_4 &&
        entryusdtValid_5 && entryusdtValid_6 && entryusdtValid_7 && entryusdtValid_8 && entryusdtValid_9 &&
        entryratioValid_1 && entryratioValid_2 && entryratioValid_3 && entryratioValid_4 &&
        entryratioValid_5 && entryratioValid_6 && entryratioValid_7 && entryratioValid_8 && entryratioValid_9
        ) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [leverageValid, totalbenefitValid, startratioValid, confirmedratioValid, MaxratioValid,
      benefitratioValid, losscutUsdtValid, emaStandardValid, entryusdtValid_1, entryusdtValid_2, entryusdtValid_3, entryusdtValid_4,
      entryusdtValid_5, entryusdtValid_6, entryusdtValid_7, entryusdtValid_8, entryusdtValid_9, entryratioValid_1, entryratioValid_2,
      entryratioValid_3, entryratioValid_4, entryratioValid_5, entryratioValid_6, entryratioValid_7, entryratioValid_8, entryratioValid_9
      ]);

    useEffect(() => {
        fetch(`/get_user_symbols_kp`)
        .then(res => res.json())
        .then(data => setSymbolList(data.signal))
        .catch(err => console.error(err));
    },[symbol, uid]);

    const onClickSearch = (symbol) => {
      let urlName
      const str = symbol;
      console.log(str);
      if(str === 'default'){
        urlName = 'default'
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
      fetch(`/setdata_kp/${urlName}/${setlevel}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        console.log('db에서 성공적으로 데이터 받아옴');
        setLeverage(result[0].leverage_info);
        setBenefitMode(result[0].benefit_mode);

        setBenefitRatio(result[0].benefit_ratio);
        setLosscutUsdt(result[0].losscut_usdt);
        
        setStartRatio(result[0].start_ratio);
        setConfirmedRatio(result[0].confirmed_ratio);
        setMaxRatio(result[0].max_ratio);

        setReverseMode(result[0].reverse_mode);

        setEntryStandard(result[0].entry_standard);
        setEmaStandard(result[0].ema_standard);
        setEmaLosscut(result[0].ema_losscut);
        setEntryStandardCandle(result[0].entry_standard_candle);
        setEntryStandardType(result[0].entry_standard_type);

        setEntryUsdt_1(result[0].entry_usdt_1);
        setEntryUsdt_2(result[0].entry_usdt_2);
        setEntryUsdt_3(result[0].entry_usdt_3);
        setEntryUsdt_4(result[0].entry_usdt_4);
        setEntryUsdt_5(result[0].entry_usdt_5);
        setEntryUsdt_6(result[0].entry_usdt_6);
        setEntryUsdt_7(result[0].entry_usdt_7);
        setEntryUsdt_8(result[0].entry_usdt_8);
        setEntryUsdt_9(result[0].entry_usdt_9);

        setEntryRatio_1(result[0].entry_ratio_1);
        setEntryRatio_2(result[0].entry_ratio_2);
        setEntryRatio_3(result[0].entry_ratio_3);
        setEntryRatio_4(result[0].entry_ratio_4);
        setEntryRatio_5(result[0].entry_ratio_5);
        setEntryRatio_6(result[0].entry_ratio_6);
        setEntryRatio_7(result[0].entry_ratio_7);
        setEntryRatio_8(result[0].entry_ratio_8);
        setEntryRatio_9(result[0].entry_ratio_9);

        setLongCount(result[0].long_count);
        setShortCount(result[0].short_count);

        setEntryCandle(result[0].entry_candle);
        setDirection(result[0].direction);

        setTradeStart(result[0].trade_start);
        setBenefit_stop(result[0].current_symbol_stop);
        setCurrentCoin_stop(result[0].current_coin_clear);
        setAllCoin_stop(result[0].all_coin_clear);
        setEnd(result[0].end);

        const e_checklist = isItemInList(result[0].symbol, e_items);
        const w_checklist = isItemInList(result[0].symbol, w_items);
        
        if(str !== 'default'){
          result.forEach(item => {
            // console.log('item',item)
            if ((item.trade_start === 1 || item.trade_start === '1') && e_checklist === false) {
              addListItem(item.symbol, setE_Items);
            }
            if ((item.trade_start === 0 || item.trade_start === '0') && e_checklist === true) {
              removeListItem(item.symbol, setE_Items);
            }
          
            // Waiting coin 리스트 삽입 및 삭제
            if ((item.current_symbol_stop === 1 || item.current_symbol_stop === '1') && w_checklist === false) {
              addListItem(item.symbol, setW_Items);
            }
            if ((item.current_symbol_stop === 0 || item.current_symbol_stop === '0') && w_checklist === true) {
              removeListItem(item.symbol, setW_Items);
            }
          });
        };

        console.log('e_items',e_items);
        console.log('e_checklist',e_checklist);
      })
      .catch((error) => {
        console.log('에러남');
      })
    }

    const onClickStart = () => {

      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      let confirmed = false

      if (trade_start === 0 || trade_start === "0"){
        confirmed = window.confirm(symbol + '의 매매를 시작하시겠습니까?');
      }else if (trade_start === 1 || trade_start === "1"){
        confirmed = window.confirm(symbol + '의 셋팅값을 변경하시겠습니까?');
      }

      if (confirmed) {
        console.log('스타트 버튼 클릭')
        fetch('/start_kp', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            symbol,
            leverage_info,
            benefit_mode,
            benefit_ratio,
            losscut_usdt,
            start_ratio,
            confirmed_ratio,
            max_ratio,
            reverse_mode,
            entry_standard,
            ema_standard,
            ema_losscut,
            entry_standard_candle,
            entry_standard_type,
            entry_usdt_1,
            entry_usdt_2,
            entry_usdt_3,
            entry_usdt_4,
            entry_usdt_5,
            entry_usdt_6,
            entry_usdt_7,
            entry_usdt_8,
            entry_usdt_9,
            entry_ratio_1,
            entry_ratio_2,
            entry_ratio_3,
            entry_ratio_4,
            entry_ratio_5,
            entry_ratio_6,
            entry_ratio_7,
            entry_ratio_8,
            entry_ratio_9,
            entry_candle,
            direction
            }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          onClickSearch(symbol);
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };

      onClickSearch(symbol);
    };

    // 익절 후 정리
    const onClickBenefit_stop = (symbol) => {
      const confirmed = window.confirm('Do you want to clean up the selected coin after profiting?');

      if (confirmed) {
        setBenefit_stop(true);
        let urlName
        const str = symbol;
        console.log(str);
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_kp/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
      onClickSearch(symbol);
    }

    // 익절 후 정리 취소 
    const onClickBenefit_cancel = (symbol) => {
      const confirmed = window.confirm('Do you want to cancel clearing after profiting the selected coins?');

      if (confirmed) {
        setBenefit_cancel(true);
        let urlName
        const str = symbol;
        console.log(str);
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_cancel_kp/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit_cancel에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    // 현재 코인 정리 
    const onClickCurrentCoin_stop = (symbol) => {
      const confirmed = window.confirm('Would you like to liquidate the selected coins right away?');

      if (confirmed) {
        setCurrentCoin_stop(true);
        const str = symbol;
        console.log(str);
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_current_coin_clear_kp/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    //진입중인 모든 코인 정리
    const onClickAllCoin_stop = () => {
      const confirmed = window.confirm('Do you really want to liquidate all coins that are currently entering the market?');

      if (confirmed) {
        setAllCoin_stop(true);
        const str = symbol;
        console.log(str);
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_all_coin_clear_kp/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    //로그아웃
    const onClickEnd = () => {
        const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
        if (!uuid) {
          alert('로그인 정보가 존재하지 않습니다.');
          return;
        }
        // 로그아웃 요청을 서버로 보냅니다.
        fetch('/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: uuid })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('로그아웃 요청 실패');
          }
          console.log('로그아웃 성공');
          alert('Logout is successful.');
          window.location.href = '/';
        })
        .catch(error => {
          console.error('로그아웃 요청 중 오류 발생:', error);
        });
      // UUID를 서버로 보내는 예시 코드

    }

    return (
      <main className="kp-console">
        <div className="kp-console__glare" aria-hidden="true" />
        <section className="kp-console__panel">
          <header className="kp-hero">
            <p className="kp-hero__eyebrow">Bitsoop auto trade system</p>
            <h1 className="kp-hero__title">KinPoint cockpit</h1>
            <p className="kp-hero__subtitle">
              시그널 기반 KP 전략을 한 화면에서 제어하세요. UID 상태와 실시간 리스트를 통해 흐름을 즉시 파악할 수 있습니다.
            </p>
            <div className="kp-hero__meta">
              <span className="kp-hero__uid">UID {uid || "—"}</span>
              <span>{nickname ? `${nickname}님 환영합니다` : "계정 정보를 불러오는 중"}</span>
            </div>
          </header>

          <div className="kp-console__layout">
            <div className="kp-console__main">
              <article className="kp-card kp-card--controls">
                <div className="kp-symbol-controls">
                  <div className="kp-symbol-dropdown" ref={symbolDropdownRef}>
                    <button
                      type="button"
                      className={`kp-symbol-dropdown__trigger ${isSymbolMenuOpen ? "is-open" : ""}`}
                      onClick={toggleSymbolMenu}
                      aria-haspopup="listbox"
                      aria-expanded={isSymbolMenuOpen}
                    >
                      <span className="kp-symbol-dropdown__current">{currentSymbolLabel}</span>
                      <span className="kp-symbol-dropdown__chevron" aria-hidden="true" />
                    </button>
                    {isSymbolMenuOpen && (
                      <div className="kp-symbol-dropdown__menu" role="listbox">
                        <button
                          type="button"
                          className={`kp-symbol-dropdown__option ${symbol === "default" ? "is-active" : ""}`}
                          onClick={() => handleSymbolSelect("default")}
                        >
                          symbol select
                        </button>
                        {selectableSymbols.length > 0 ? (
                          <>
                            <div className="kp-symbol-dropdown__divider" />
                            {selectableSymbols.map((sym) => (
                              <button
                                key={sym}
                                type="button"
                                className={`kp-symbol-dropdown__option ${sym === symbol ? "is-active" : ""}`}
                                onClick={() => handleSymbolSelect(sym)}
                              >
                                {sym}
                              </button>
                            ))}
                          </>
                        ) : (
                          <div className="kp-symbol-dropdown__empty">등록된 심볼이 없습니다</div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="kp-symbol-controls__buttons">
                    <button onClick={handleOpenPopup} className="button_benefit_c_ut">
                      추 가
                    </button>
                    <button onClick={() => deleteSymbol(symbol)} className="button_benefit_c_ut">
                      삭 제
                    </button>
                  </div>
                </div>
                <SymbolSearchPopup
                  isOpen={isPopupOpen}
                  onAdd={handleAddSymbol}
                  onClose={handleClosePopup}
                  anchorPosition={popupAnchor}
                />
              </article>

              <article className="kp-card kp-card--form">
                <div className="contentWrap_sp">
                  <div className="line"></div>

                  <div className="center_text_lever">Basic setting</div>
              <div className="leverage_container">
                <div class="leverage_item_kp">진입 기준 시간봉</div>
                <select className="select_samaria" value={entry_candle} onChange={handleEntryCandle}>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                </select>
                <div class="leverage_item_kp">진입 방향 설정</div>
                <select className="select_samaria" value={direction} onChange={handleDirection}>
                  <option value="both">양방향</option>
                  <option value="long">롱</option>
                  <option value="short">숏</option>
                </select>
              </div>

              <div class="leverage_container">
                <div class="leverage_item_kp">Set Leverage</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={leverage_info}
                onChange={handleLeverage} />
              <div class="leverage_item_kp">익절 모드</div>
                <select className="select_samaria" value={benefit_mode} onChange={handleBenefitMode}>
                  <option value="kinpoint">킨포인트</option>
                  <option value="max_benefit">최대익절</option>
                </select>
              </div>

              <div class="leverage_container">
                <div class="leverage_item_kp"
                style={{
                    filter: (benefit_mode === 'max_benefit') ? 'blur(5px)' : 'none',
                  }}>최소 익절률(%)</div>
                <input 
                type="number"
                class="leverage_input_basic"
                disabled={benefit_mode === 'max_benefit'} 
                  style={{
                    filter: (benefit_mode === 'max_benefit') ? 'blur(5px)' : 'none',
                  }}
                value={benefit_ratio}
                onChange={handleBenefitratio} />
                <div class="leverage_item_kp" style={{
                    filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                  }}>작동률(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                disabled={benefit_mode !== 'max_benefit'} 
                  style={{
                    filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                  }}
                value={start_ratio}
                onChange={handleStartRatio} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item_kp" style={{
                    filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                  }}>확정률(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                disabled={benefit_mode !== 'max_benefit'} 
                style={{
                  filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                }}
                value={confirmed_ratio}
                onChange={handleConfirmedRatio} />
                <div class="leverage_item_kp" 
                style={{
                  filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                }}>최대익절비율(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                disabled={benefit_mode !== 'max_benefit'} 
                style={{
                  filter: (benefit_mode !== 'max_benefit') ? 'blur(5px)' : 'none',
                }}
                value={max_ratio}
                onChange={handleMaxRatio} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item_kp">손절 셋팅(USDT)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={losscut_usdt}
                onChange={handleLosscutUsdt} />
                <div class="leverage_item_kp">역진입 설정</div>
                <select className="select_samaria" value={reverse_mode} onChange={handleReverseMode}>
                  <option value="no">미적용</option>
                  <option value="apply">적용</option>
                </select>
              </div>
            
            <div className="line"></div>

              <div className="center_text_lever">보조 기준</div>
              <div className="leverage_container">
                <div class="leverage_item">보조 적용</div>
                <select className="select_samaria" value={entry_standard} onChange={handleEntryStandard}>
                  <option value="apply">적용</option>
                  <option value="no">미적용</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}>EMA 기준봉갯수</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={ema_standard}
                onChange={handleEmaStandard}
                disabled={entry_standard !== 'apply'}
                style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}/>
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }} >EMA 손절적용</div>
                <select className="select_samaria" value={ema_losscut}
                disabled={entry_standard !== 'apply'}
                style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}
                onChange={handleEmaLosscut}>
                  <option value="no">미적용</option>
                  <option value="apply">적용</option>
                </select>
              </div>

              <div className="leverage_container">
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}>보조 시간봉</div>
                <select className="select_samaria" value={entry_standard_candle}
                disabled={entry_standard !== 'apply'}
                style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}
                onChange={handleEntryStandardCandle}>
                  <option value="3m">3 분봉</option>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  <option value="1d">1 일봉</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }} >신호 기준</div>
                <select className="select_samaria" value={entry_standard_type}
                disabled={entry_standard !== 'apply'}
                style={{
                  filter: (entry_standard !== 'apply') ? 'blur(5px)' : 'none',
                }}
                onChange={handleEntryStandardType}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
              </div>
              
            <div className="line"></div>

            <div className="center_text_lever">현재 진입 횟수</div>
              <div class="leverage_container">
                <div class="leverage_item_kp">롱진입 횟수</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={long_count}
                disabled={true} />
                <div class="leverage_item_kp">숏진입 횟수</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={short_count}
                disabled={true} />
              </div>
            {/* 레버리지 셋팅  레버리지 셋팅 레버리지 셋팅 레버리지 셋팅 레버리지 셋팅*/}
            <div className="line"></div>
              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">순 서</div>
                <div class="leverage_item_kp">USDT</div>
                <div class="leverage_item_kp">간격(%)</div>
              </div>
              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">1st set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_1}
                onChange={handleEntryUsdt_1} />
                <input
                type="number"
                class="leverage_input_kp"
                disabled={true} 
                style={{
                  filter: (true) ? 'blur(5px)' : 'none',
                }}
                value={entry_ratio_1}
                onChange={handleEntryRatio_1} />
                {/* <div class="leverage_item_kp leverage_hidden">Entry interval(%)</div>
                <input type="text" class="leverage_input_kp leverage_hidden" /> */}
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">2nd set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_2}
                onChange={handleEntryUsdt_2} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_2}
                onChange={handleEntryRatio_2} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">3rd set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_3}
                onChange={handleEntryUsdt_3} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_3}
                onChange={handleEntryRatio_3} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">4th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_4}
                onChange={handleEntryUsdt_4} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_4}
                onChange={handleEntryRatio_4} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">5th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_5}
                onChange={handleEntryUsdt_5} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_5}
                onChange={handleEntryRatio_5} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">6th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_6}
                onChange={handleEntryUsdt_6} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_6}
                onChange={handleEntryRatio_6} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">7th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_7}
                onChange={handleEntryUsdt_7} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_7}
                onChange={handleEntryRatio_7} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">8th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_8}
                onChange={handleEntryUsdt_8} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_8}
                onChange={handleEntryRatio_8} />
              </div>

              <div class="leverage_container_center_kp">
                <div class="leverage_item_kp">9th set</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_kp"
                value={entry_usdt_9}
                onChange={handleEntryUsdt_9} />
                <input
                type="number"
                class="leverage_input_kp"
                value={entry_ratio_9}
                onChange={handleEntryRatio_9} />
              </div>
            
            <div className="line"></div>
            
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickStart()} className="bottomButton_sp_lever">
                매매 시작
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickBenefit_stop(symbol)} disabled={benefit_stop === 1 || trade_start === 0 || benefit_stop === '1' || trade_start === '0'} className="button_benefit_c_lever">
                익절 후 정리
                </button>
                <button onClick={() => onClickBenefit_cancel(symbol)} disabled={benefit_stop === '0' || benefit_stop === 0} className="button_benefit_c_lever">
                취 소
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickCurrentCoin_stop(symbol)} disabled={(symbol === 'default' && trade_start === 0 &&  benefit_stop === 0) || (symbol === 'default' && trade_start === '0' &&  benefit_stop === '0') || setlevel <= 7} className="bottomButton_sp_lever">
                현재 코인 정리
                </button>
                {/* <button onClick={() => onClickAllCoin_stop()} disabled={symbol === 'default' && setlevel <= 7} className="button_benefit_c_lever">
                All symbol close
                </button> */}
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                로그아웃
                </button>
             </div>
              </article>
            </div>

            <aside className="kp-console__side">
              <article className="kp-card kp-card--list">
                <div className="list_box_title_lever">진입중인 코인 리스트</div>
                <ul className="list_box_lever">
                  {e_items.map((item, index) => (
                    <li key={index} className="list_item" onClick={() => onClickCoin(item)}>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>

              <article className="kp-card kp-card--list">
                <div className="list_box_title_lever">익절 후 정리 리스트</div>
                <ul className="list_box_lever">
                  {w_items.map((item, index) => (
                    <li key={index} className="list_item" onClick={() => onClickCoin(item)}>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>
            </aside>
          </div>
        </section>
      </main>
    );
}